import React from 'react';
import './pages.css';
import './servicespage.css'
import bgmshops from '../images/bgservices.webp';
import '../Components/services.css';
import ServicesList from '../Components/ServicesList.js';
import Ecommerce from '../Components/Ecommerce.js';

function ServicesPage() {
    return (
        <>
         <section className='pagesIndex' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                    <div className='content'>
                        <p className='subtitles'>WHAT WE DO</p>
                        <h2><span>INDEX<div className='registered'>®</div><i>-</i></span></h2>
                        <div className='textoWorks'>
                            <h3>Services of <strong>Index®</strong></h3>
                            <p>Generamos experiencias digitales que les permiten a las marcas lograr un nuevo canal de fidelización.</p>
                        </div>
                    </div>

        </section>
        <section className='serviciosPage' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
            <div className='content'>
                <ServicesList />
                <Ecommerce />
            </div>
        </section>
        </>
    )
}
export default ServicesPage;